import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { State } from 'app/e-form/model/eform-type';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-phone-properties',
  templateUrl: './phone-properties.component.html',
  styleUrls: ['./phone-properties.component.scss']
})
export class PhonePropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Input() table: State;
   helper = new EFormHelper();
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;
   constructor() { }

   ngOnInit(): void {
      this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      });
   }

   _setOption(value: any, type: string) {
      if (this.table) {
         this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex).get(type).setValue(value);
         this.helper.getFieldTableAsFormArray(this.eForm, this.state.sectionIndex, this.state.fieldIndex).updateValueAndValidity();
      } else {
         this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex).get(type).setValue(value);
         this.helper.getFieldAsFormArray(this.eForm, this.state.sectionIndex).updateValueAndValidity();
      }
   }


}
